<template>
  <div class="manual-usuario container-fluid">
    <div class="row">
      <!-- Contenido principal -->
      <main class="col-12 p-3">
  <!-- Buscador -->
  <div class="mb-4">
    <input v-model="busqueda" class="form-control" type="text" placeholder="🔍 Buscar por módulo o contenido..." @keyup.enter="buscarContenido" />
  </div>

  <!-- Videos con descripción y guía expandible -->
  <div class="row g-4">
    <div class="col-md-6" v-for="video in videosFiltrados" :key="video.id">
      <div class="card shadow-sm h-100">
        <div class="ratio ratio-16x9">
          <iframe :src="video.video" title="Video" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div class="card-body">
          <h6 class="card-title fw-bold">{{ video.id }}. {{ video.titulo }}</h6>
          <p class="card-text small text-muted">{{ video.descripcion }}</p>
          <button v-if="video.contenidoHTML" class="btn btn-outline-primary btn-sm mt-2" @click="video.show = !video.show">
            {{ video.show ? 'Ocultar' : '📄 Ver Guía Escrita' }}
          </button>
          <div v-if="video.show" class="mt-3 bg-light p-3 rounded" v-html="video.contenidoHTML"></div>
        </div>
      </div>
    </div>
  </div>
</main>

    </div>
  </div>
</template>

<script setup>




import { ref, computed } from 'vue'





const busqueda = ref('')

const capacitaciones = ref([
  {
    id: 1,
    titulo: 'Planificación del Cultivo',
    video: 'https://www.youtube.com/embed/r3tMPRvJgkI?si=Ggrl0eFBuFJJC2iD',
    descripcion: 'Primer paso: cómo estructurar etapas y tareas para tu cultivo.',
    show: false,
    contenidoHTML: `
      <p>Este sistema está diseñado para facilitar la gestión completa de un club de cultivo, desde la siembra hasta el envasado del producto final.</p>
      <p>Permite planificar, ejecutar y trazar todas las tareas agrícolas y de transformación asociadas a las plantas. Es útil tanto para cultivadores como para técnicos responsables, gestores o administradores del club.</p>
      <ul>
        <li><strong>Evento / Etapa:</strong> Fase del ciclo del cultivo (ej. germinación, vegetativo, cosecha, etc.).</li>
        <li><strong>Plan de Cultivo:</strong> Planificación anticipada de tareas por etapa, con costos estimados.</li>
        <li><strong>Tarea:</strong> Acción concreta que debe realizarse (riego, poda, etc.).</li>
        <li><strong>Bloquear Lote:</strong> Paso necesario para empezar a trabajar el lote.</li>
        <li><strong>Proyecto:</strong> En este sistema equivale a "cultivo".</li>
      </ul>
      <ol>
        <li><strong>Crear cultivo:</strong> definí fechas, lotes y si querés, usá un plan predefinido.</li>
        <li><strong>Planificar tareas:</strong> agregá tareas por etapa con costos estimados.</li>
        <li><strong>Ejecutar tareas reales:</strong> registrá lo que hacés cada día (aunque no tengas plan).</li>
        <li><strong>Cosechar y generar biomasa:</strong> desde los lotes activos.</li>
        <li><strong>Transformar en producto:</strong> convertí biomasa en materia prima → producto bulk → envasado.</li>
        <li><strong>Gestionar inventario y trazabilidad:</strong> insumos usados, procesos y resultados.</li>
      </ol>
      <p><strong>Importante:</strong> No necesitás crear un plan para operar. Podés registrar tareas reales directamente.</p>
    `
  },
  {
    id: 2,
    titulo: 'Inventario del Cultivador',
    video: 'https://www.youtube.com/embed/t_BqCgVTTI8?si=2BiY6A_x224C9EBR',
    descripcion: 'Cargá insumos correctamente y aprendé cómo impactan en el costo real.',
    show: false,
    contenidoHTML: `
      <p>Registrá todos los insumos utilizados en el cultivo: macetas, fertilizantes, herramientas, guantes, etc. Cada insumo puede tener una unidad de medida (mililitros, gramos, unidades, etc.) y un <strong>precio unitario</strong> que será clave para calcular los costos reales de producción.</p>
      <p>Cuando se ejecutan tareas (por ejemplo, fertilización), el sistema permite seleccionar los insumos utilizados y su cantidad. Automáticamente se descuenta del stock y se multiplica por el precio unitario para obtener el <strong>costo real de esa tarea</strong>.</p>
      <p><strong>Ejemplo:</strong> si usás 5 mililitros de un fertilizante que cuesta $100 por mililitro, el sistema calculará un costo de $500 para esa tarea. Esta información alimenta los reportes de costos, eficiencia y gestión operativa.</p>
      <ul>
        <li>Ingresá correctamente los precios al cargar el inventario.</li>
        <li>Verificá el stock disponible antes de realizar tareas.</li>
        <li>Usá unidades coherentes para evitar errores en cálculos.</li>
      </ul>
    `
  },
  {
    id: 3,
    titulo: 'Módulo de Gestión de Variables',
    video: 'https://www.youtube.com/embed/90wvvzzh1dM?si=xu5N_DLzKGDDiIPZ',
    descripcion: 'Configurá variables clave como temperatura, humedad, pH y más.',
    show: false,
    contenidoHTML: ``
  },
  {
    id: 4,
    titulo: 'Cultivo, Lotes y Eventos',
    video: 'https://www.youtube.com/embed/zFmADoVRoKE?si=WZWifV_P3F4v71mx',
    descripcion: 'Administrá el cultivo: genética de plantas, lotes, códigos y eventos como germinación, vegetativo y cosecha.',
    show: false,
    contenidoHTML: `
      <p>Los lotes agrupan plantas similares (por variedad, sala, fecha, etc.).</p>
      <ul>
        <li>Bloquear lote es necesario para que quede operativo.</li>
        <li>Intentá mantener homogeneidad en los lotes para facilitar carga y trazabilidad.</li>
      </ul>
    `
  },
  {
    id: 5,
    titulo: 'Creación de Tareas Operativas',
    video: 'https://www.youtube.com/embed/5oj6LtoiJuI?si=cXXVCkT7GASftAbr',
    descripcion: 'Registrá tareas reales con costos, personal, inventario y normativas asociadas. Todo trazable.',
    show: false,
    contenidoHTML: `
      <p>Corazón operativo del sistema. Se registra lo que se hizo en el día, con o sin plan.</p>
      <ul>
        <li>Nombre, descripción, personas que trabajaron.</li>
        <li>Horas de trabajo, insumos usados.</li>
        <li>Costo real y si fue o no planificada.</li>
        <li>Vínculo opcional a normativa/procedimiento/ley cargada en el sistema.</li>
      </ul>
      <p>Podés asociar tareas a cualquier normativa relevante: ARICCAME, procedimientos internos, HACCP, etc.</p>
    `
  },
  {
    id: 6,
    titulo: 'Cosecha y Gestión de Biomasa',
    video: 'https://www.youtube.com/embed/Qv-LyZ_4_7M?si=VEwfCoKe82DBMh-k',
    descripcion: 'Pasá de planta a producto: cosecha, tipos de biomasa y comienzo del proceso productivo.',
    show: false,
    contenidoHTML: `
      <p>La biomasa solo se puede crear en eventos de cosecha. Es recomendable:</p>
      <ul>
        <li>Generar pocas biomasas por lote (ej: flores, ramas, semillas).</li>
        <li>Trabajar unidades grandes, fáciles de seguir.</li>
        <li>Evitar fraccionar sin necesidad. Misma lógica para materia prima, bulk y envasado.</li>
      </ul>
    `
  },
  {
    id: 7,
    titulo: 'Transformación y Trazabilidad',
    video: 'https://www.youtube.com/embed/seXA6FUvxDI?si=Xd9drBDFYgROIDFY',
    descripcion: 'Convertí biomasa en materia prima y productos envasados. Trazabilidad completa por códigos.',
    show: false,
    contenidoHTML: `
      <ul>
        <li>Definí lotes homogéneos y fáciles de manejar.</li>
        <li>Agrupá biomasa y productos para simplificar gestión.</li>
        <li>Usá buenas descripciones. Registrá todo (personas, insumos, horas).</li>
        <li>Verificá inventario antes de tareas clave.</li>
      </ul>
    `
  },
  {
    id: 8,
    titulo: 'Dispensación y Trazabilidad Final',
    video: 'https://www.youtube.com/embed/GuTpzLudAWQ?si=Ig41Vc80kp65Xz7J',
    descripcion: 'Dispensá productos envasados a usuarios medicinales y revisá su trazabilidad completa hacia atrás.',
    show: false,
    contenidoHTML: `
    <p>El grafo muestra el recorrido completo desde la planta hasta el producto final envasado. Asegura control y transparencia.</p>
    `
  }
])





function buscarContenido(id) {
  const match = capacitaciones.value.find(s => s.id === id)
  return match ? match.contenidoHTML : ''
}

const videosFiltrados = computed(() =>
  capacitaciones.value.filter(v =>
    v.titulo.toLowerCase().includes(busqueda.value.toLowerCase()) ||
    v.descripcion.toLowerCase().includes(busqueda.value.toLowerCase())
  )
)



</script>

<style scoped>
.manual-usuario {
  font-family: "Roboto", sans-serif; /* Cambié la fuente a Roboto para un aspecto más moderno */
  background-color: #f4f4f9; /* Color de fondo más suave */
  min-height: 100vh;
  color: #333;
  padding: 20px; /* Añadí padding para un mejor espaciado */
}

.card {
  border-radius: 10px; /* Bordes más redondeados para un diseño más moderno */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Sombra más suave */
  transition: transform 0.2s ease-in-out; /* Transición suave al pasar el ratón */
}

.card:hover {
  transform: translateY(-5px); /* Efecto de elevación al pasar el ratón */
}

.card-title {
  color: #1a1a2e; /* Color de texto más oscuro para mejor contraste */
  font-weight: 700; /* Texto más grueso para títulos */
}

.card-text {
  font-size: 0.9rem;
  color: #4a4a4a; /* Color de texto más suave */
}

.btn {
  border-radius: 20px; /* Botones más redondeados */
  transition: background-color 0.3s ease;
}

.btn-outline-primary {
  color: #1a1a2e;
  border-color: #1a1a2e;
}

.btn-outline-primary:hover {
  background-color: #1a1a2e;
  color: #fff;
}

input.form-control {
  border-radius: 20px; /* Bordes más redondeados para el input */
  border: 1px solid #ccc;
  padding: 10px;
}

input.form-control:focus {
  border-color: #1a1a2e;
  box-shadow: 0 0 5px rgba(26, 26, 46, 0.2);
}

.ratio {
  aspect-ratio: 16 / 9;
  max-width: 100%;
  height: auto;
}

.ratio iframe {
  width: 100%;
  height: 100%; /* Ajustar la altura para que se adapte al contenedor */
  border-radius: 10px 10px 0 0;
}

.alert-info {
  background-color: #e3f4ec;
  border-left: 6px solid #4a7d3a;
  color: #205375;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.alert-info i {
  font-size: 1.5rem;
  color: #4a7d3a;
}

.alert-info p {
  margin-bottom: 0;
}

.sidebar {
  background: #f4fdf7;
  border-right: 1px solid #cde0d2;
  height: 100vh;
  position: sticky;
  top: 0;
  overflow-y: auto;
  border-radius: 0 10px 10px 0;
}

.sidebar h5 {
  color: #205375;
  font-weight: 600;
  border-bottom: 1px solid #ccc;
  padding-bottom: 0.5rem;
}

.nav-link {
  font-size: 0.95rem;
  color: #205375;
  padding: 6px 10px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.nav-link:hover {
  background-color: #e3f4ec;
  text-decoration: none;
  font-weight: 500;
}

.accordion-button {
  background-color: #ffffff;
  color: #205375;
  font-weight: bold;
  border: none;
  box-shadow: none;
  transition: background-color 0.2s ease;
}

.accordion-button:hover {
  background-color: #e3f4ec;
}

.accordion-body {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 1.5rem 2rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  border-left: 6px solid #28a745;
}

.row.g-4 {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.col-md-6 {
  flex: 1 1 100%; /* Ocupa el 100% del ancho en pantallas pequeñas */
  max-width: 100%;
}

@media (min-width: 768px) {
  .col-md-6 {
    flex: 1 1 calc(33.333% - 1rem); /* Ajustar para que quepan tres por fila en pantallas medianas y grandes */
    max-width: calc(33.333% - 1rem);
  }
}
</style>
